module.exports = __webpack_public_path__ + "img/zoom.10e57791.png";